import { Box, Button, Typography, useTheme } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import {
  primaryColorBlack,
  primaryColorWhite,
} from "../../../utils/styles";
import customButtonStyles from "./CustomButton.styles";

interface CustomProps {
  label: string;
  onClick: Function;
  variant?: "contained" | "outlined" | "text";
  loading?: boolean;
  customClasses?: any;
  buttonType?: string;
  startIcon?: JSX.Element;
  endIcon?: JSX.Element;
  disabled?: boolean;
}

const CustomButton = (props: CustomProps) => {
  const theme = useTheme();
  
  const getCustomCss = () => {
    switch (props.buttonType) {
      case "transparentBtn":
        return {
          ...classes.transparentBtn,
          color: theme.palette.text.primary,
        };
      case "gradientBtn":
        return theme.palette.mode === "dark"
          ? {
              ...classes.darkBtn,
              background: "#FFFFFF",
              color: "#000000",
              "&:hover": {
                background: "#F5F5F5",
                boxShadow: "0 8px 24px rgba(255, 255, 255, 0.2)",
              },
              "&:active": {
                background: "#E0E0E0",
              },
            }
          : classes.darkBtn;
      case "transparentGradientBtn":
        return {
          ...classes.transparentBtn,
          color: theme.palette.text.primary,
        };
      case "borderedBtn":
        return {
          ...classes.borderedBtn,
          border: `1px solid ${theme.palette.text.primary}`,
          color: theme.palette.text.primary,
        };
      case "secondaryBtn":
        return {
          ...classes.secondaryBtn,
          background: theme.palette.background.paper,
          color: theme.palette.text.secondary,
        };
      default:
        return {};
    }
  };

  const classes = customButtonStyles;
  const buttonType = getCustomCss();
  const appliedClass = {
    ...classes.btnStyle,
    ...buttonType,
    ...(props.customClasses ?? {}),
  };

  const processing = props.loading ? props.loading : false;

  return (
    <Button
      variant={props.variant}
      startIcon={props.startIcon}
      endIcon={props.endIcon}
      sx={appliedClass}
      onClick={(event) => props.onClick(event)}
      disabled={props.loading ?? props.disabled}
    >
      <Box sx={classes.btnInnerBox}>
        {processing ? (
          <Box sx={classes.loading}>
            <CircularProgress size={20} sx={{ color: primaryColorBlack }} />
          </Box>
        ) : (
          <>
            <Typography
              className="animateY1"
              sx={{
                ...classes.mainText,
                ...(props.buttonType === "transparentGradientBtn"
                  ? { ...classes.mainText1, ...classes.gradientText }
                  : {}),
                ...(props.buttonType === "gradientBtn" || props.buttonType === "darkBtn"
                  ? theme.palette.mode === "dark"
                    ? { color: "#000000" }
                    : { color: primaryColorWhite }
                  : {}),
                ...(props.buttonType === "transparentBtn" ||
                props.buttonType === "borderedBtn"
                  ? { color: theme.palette.text.primary }
                  : {}),
              }}
            >
              {props.label}
            </Typography>
            <Typography
              className="animateY2"
              aria-hidden="true"
              sx={{
                ...classes.subText,
                ...(props.buttonType === "transparentGradientBtn"
                  ? { ...classes.subText1, ...classes.gradientText }
                  : {}),
                ...(props.buttonType === "gradientBtn" || props.buttonType === "darkBtn"
                  ? theme.palette.mode === "dark"
                    ? { color: "#000000" }
                    : { color: primaryColorWhite }
                  : {}),
                ...(props.buttonType === "transparentBtn" ||
                props.buttonType === "borderedBtn"
                  ? { color: theme.palette.text.primary }
                  : {}),
              }}
            >
              {props.label}
            </Typography>
          </>
        )}
      </Box>
    </Button>
  );
};

export default CustomButton;
